import axios from '../../http'
import { handleGetRequestParams } from '../../common/js/util'

class Supplier {
  // 获取商城基础信息
  getXBBasicInformation() {
    const url = `/api/index/setting`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 供应商设置信息
  getSupplierBasicInformation() {
    const url = `/api/supplier/setting`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 供应商登录
  postSupplierLogin(data) {
    const url = '/api/supplier/login'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //供应商注册
  postSupplierRegister(data) {
    const url = '/api/supplier/register'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //供应商无账号发送验证码
  getSendCode(telephone) {
    const url = `/api/common/supplier/sign/send/code?telephone=${telephone}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //供应商发送验证码
  getSupplierCode(telephone) {
    const url = `/api/common/supplier/send/code?telephone=${telephone}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //供应商check验证码
  postSupplierCheckCode(data) {
    const url = '/api/common/supplier/check/code'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //供应商忘记密码修改密码接口
  postUpdateSupplierPassword(data) {
    const url = '/api/supplier/modify'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //获取供应商信息
  getSupplierInfo() {
    const url = `/api/supplier/info`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //供应商信息编辑
  postUpdateSupplierInfo(data) {
    const url = '/api/supplier/update'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //供应商商品列表
  getSupplierGoods(options) {
    let url = `/api/supplier/goods/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 供应商品牌
  getSupplierBrand() {
    const url = `/api/supplier/common/brand/list`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //供应商分类列表
  getSupplierClassify() {
    const url = `/api/supplier/common/goodscate/list`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //供应商标签列表
  getSupplierLabel() {
    const url = `/api/supplier/common/label/list`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //供应商运费模板
  getSupplierTraffic() {
    const url = `/api/supplier/common/traffic/list`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //供应商参数列表
  getSupplierParams(searchValue, currentPage, groupId) {
    const url = `/api/supplier/common/params/list?searchValue=${searchValue}&currentPage=${currentPage}&groupId=${groupId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取供应商参数组列表
  getParameterGroupList(groupName) {
    const url = `/api/supplier/common/params/group/list?groupName=${groupName}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //供应商规格列表
  getSupplierSpecList() {
    const url = `/api/supplier/common/spec/list`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //供应商添加规格
  postSupplierAddSpec(data) {
    const url = `/api/supplier/common/spec/add`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //供应商添加规格属性
  postSupplierAddSpecOption(data) {
    const url = `/api/supplier/common/spec/option/add`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //供应商添加商品
  postSupplierAddGoods(data) {
    const url = `/api/supplier/goods/save`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //供应商修改商品
  postSupplierUpdateGoods(data) {
    const url = `/api/supplier/goods/modify`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //供应商商品详情
  getSupplierGoodsDetail(id) {
    const url = `/api/supplier/goods/get?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //供应商删除商品
  getSupplierDelGoods(id) {
    const url = `/api/supplier/goods/delete?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //供应商商品上架
  getSupplierUpGoods(id) {
    const url = `/api/supplier/goods/up/sale?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //供应商商品下架
  getSupplierDownGoods(id) {
    const url = `/api/supplier/goods/down/sale?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //供应商批量处理商品
  postSupplierGoodsDeals(data) {
    const url = `/api/supplier/goods/deals`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //删除之前判断
  postSupplierBeforeDelete(data) {
    const url = `/api/supplier/goods/exam/extra`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //《---选品单---》
  //选品单列表
  getSupplierSelectionList(options) {
    let url = `/api/supplier/selection/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //选品单-审核
  getSupplierSelectionApproval(id, status) {
    const url = `/api/supplier/selection/approval?id=${id}&status=${status}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //选品单-邀约
  postSupplierSelectionInvite(data) {
    const url = `/api/supplier/selection/invite`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //选品单-编辑邀约
  postSupplierUpdateInvite(data) {
    const url = `/api/supplier/selection/modify/message`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //选品单-邀约完成
  getSupplierSelectionFinish(id) {
    const url = `/api/supplier/selection/finish?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //选品单-完成确认
  getSupplierSelectionEnd(id) {
    const url = `/api/supplier/selection/end?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //商品-设置佣金比例
  postSupplierCommissionRate(data) {
    const url = `/api/supplier/goods/update/commission/rate`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //供应商商品导入
  postSupplierUploadGoods(data) {
    const url = `/api/supplier/goods/upload`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 供应商获取商品库存列表、查询所需商品库存
  getSupplierStockGoods(options) {
    let url = `/api/supplier/goods/list/num?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //样品单列表
  getSupplierSampleList(options) {
    let url = `/api/supplier/selection/sample/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 供应商获取商品库存详情
  getSupplierDetailStockGoods(goodsId, warehouseId) {
    const url = `/api/supplier/goods/get/num?goodsId=${goodsId}&warehouseId=${warehouseId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 样品单单详情
  getSupplierSampleDetail(orderCode) {
    const url = `/api/supplier/selection/sample/detail?orderCode=${orderCode}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 供应商修改商品库存
  postSupplierStockNum(data) {
    const url = '/api/supplier/goods/modify/sale/num'
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 供应商获取所有仓库信息
  getSupplierAllWarehouse() {
    const url = '/api/supplier/common/warehouse/list'
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 供应商商品入库列表
  postSupplierStock(currentPage, start, end, orderNumber, warehouseId) {
    const url = `/api/supplier/stock/search?currentPage=${currentPage}&start=${start}&end=${end}&orderNumber=${orderNumber}&warehouseId=${warehouseId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 供应商获取入库单详情
  getSupplierDetailStock(id) {
    const url = '/api/supplier/stock/search/info?id=' + id
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 供应商商品入库
  postSupplierInStock(data) {
    const url = '/api/supplier/stock/add'
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取商品入库列表--带规格
  getCommodityListStorage() {
    let url = `/api/supplier/goods/list/storage?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 自动补货
  postReplenishment(data) {
    const url = `/api/supplier/goods/add/sale/num`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //竞价活动列表
  getSupplierBiddingList(currentPage, status) {
    const url = `/api/supplier/activity/list?currentPage=${currentPage}&status=${status}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //竞价活动详情
  getSupplierBiddingInfo(id, goodsName, status) {
    const url = `/api/supplier/activity/info?id=${id}&goodsName=${goodsName}&status=${status}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //修改竞价
  getSupplierBidding(data) {
    const url = '/api/supplier/activity/update'
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //商品列表详情
  getSupplierBiddingGoodsDetail(options) {
    let url = `/api/supplier/goods/list/info?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //竞价添加商品
  getSupplierBiddingGoodsAdd(data) {
    const url = '/api/supplier/activity/add'
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //撤销竞价活动
  getSupplierDeleteBidding(id) {
    const url = `/api/supplier/activity/cancel?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //修改竞价规则
  getSupplierModifyRule(data) {
    const url = `/api/supplier/activity/update/rule`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //竞价商品促销信息
  getSupplierBiddingGoodsInfo(id) {
    const url = `/api/supplier/activity/promotion?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //供应商通知消息
  getSupplierNotice(currentPage) {
    const url = `/api/supplier/notice?currentPage=${currentPage}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //读取消息
  getSupplierReadNotice(data) {
    const url = `/api/supplier/read`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //展位列表
  getStandList(categoryId) {
    const url = `/api/supplier/booth/list?categoryId=${categoryId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //一级分类
  getFristClassify() {
    const url = `/api/supplier/booth/category/list`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //展位基础信息
  getStandBaseInfo(boothId) {
    const url = `/api/supplier/booth/detail?boothId=${boothId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //修改展位竞价金额
  getStandModifyMoney(data) {
    const url = `/api/supplier/booth/bidding/update`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //撤销展位商品
  getRemoveStandGoods(data) {
    const url = `/api/supplier/booth/bidding/del`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //新增展位商品
  getAddStandGoods(data) {
    const url = `/api/supplier/booth/bidding/add`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //展位竞价商品
  getStandBiddingGoods(boothId) {
    const url = `/api/supplier/booth/bidding/detail?boothId=${boothId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //查询展位所属分类的子集分类
  getChildrenCate(boothId) {
    const url = `/api/supplier/booth/cateInfo?boothId=${boothId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 商品价格列表
  getGoodsPriceList(options) {
    let url = `/api/supplier/goods/price/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 修改成本价
  postUpdateCostPrice(options) {
    let url = `/api/supplier/goods/basePrice/update?`
    url += handleGetRequestParams(options)
    return axios.post(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 修改手机号（账号）
  postUpdatePhone(data) {
    const url = `/api/supplier/modify/phone`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
}

export default Supplier;
